import { Col, Collapse, Divider, Row } from 'antd';
import { TriggerComponent } from 'components/hitches/online-store/OrderCard';
import { useIntl } from 'react-intl';
import { PreviewOrderResponse } from 'services/hitchit/types/usecases/Preference';

const { Panel } = Collapse;

type AnotherOrderPickerProps = {
  onSetSelectedOrderPreview: (preview: PreviewOrderResponse) => void;
  selectedOrderPreview?: PreviewOrderResponse;
  previewOrders?: PreviewOrderResponse[];
};

export const AnotherOrderPicker = ({
  previewOrders,
  onSetSelectedOrderPreview,
  selectedOrderPreview,
}: AnotherOrderPickerProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Divider orientation="left">
        <h3>
          {formatMessage({
            defaultMessage: 'Use another sales order as example',
            description: '/onboarding/preferences/anothersaleorder/title',
          })}
        </h3>
      </Divider>
      <p>
        {formatMessage({
          defaultMessage: 'Is the preselected sales an atypical one?',
          description: '/onboarding/preferences/anothersaleorder/description/1',
        })}
      </p>
      <Collapse ghost>
        <Panel
          key="1"
          header={formatMessage({
            defaultMessage: 'Pick another one',
            description: '/onboarding/preferences/anothersaleorder/button',
          })}
        >
          <p>
            {selectedOrderPreview?.sale?.order?.isDummy
              ? formatMessage({
                  defaultMessage:
                    "We couldn't find an order in your shop just yet, therefore, we constructed a fake one to help you with your preferences.",
                })
              : formatMessage({
                  defaultMessage:
                    'We found out your last sales. We preselected one so you can imagine better what we will do once you configured this integration. If this is not a good example sale, pick another.',
                  description: '/onboarding/preferences/anothersale/description/long',
                })}
          </p>
          <Row justify="start">
            <Col span={24}>
              <Row justify="start" gutter={[32, 32]}>
                {previewOrders?.map((previewData: PreviewOrderResponse) => (
                  <Col key={previewData.sale.order.id} sm={{ span: 24 }} lg={{ span: 12 }}>
                    {previewData.sale.order && (
                      <TriggerComponent
                        trigger={previewData.sale.order}
                        selected={selectedOrderPreview?.sale.order.id === previewData.sale.order.id}
                        onChange={() => onSetSelectedOrderPreview(previewData)}
                      />
                    )}
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </>
  );
};
